import type { OfferSku } from "./schema";

export function hasPaperKingdomProductAccess(
  entitlements: readonly OfferSku[],
  canAdmin = false,
) {
  return canAdmin || entitlements.length > 0;
}
